import React, { useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { eliminarProcesoApi } from "../../utils/Datos";

export const EliminarProceso = ({
  idProcess,
  setUpdateProceso,
  yearProcess,
}) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [{ motivo }, handleInputChange] = useForm({ motivo: "" });
  const [errores, setErrores] = useState({ motivo: null });

  const eliminarProceso = async () => {
    if (cargandoDatos === false) {
      if (motivo.length <= 3) {
        setErrores({ ...errores, motivo: "Debe ingresar un motivo" });
        return false;
      }
      setCargandoDatos(true);
      eliminarProcesoApi({
        id_process: idProcess,
        comentElimination: motivo,
      }).then((respuesta) => {
        setCargandoDatos(false);
        if (respuesta.status === true) {
          setUpdateProceso(true);
          const $ = window.jQuery;
          $("#m-").modal("hide");
          Swal.fire({
            title: "Listo",
            html: "Proceso eliminado",
            icon: "success",
            confirmButtonText: "Ok",
          });
        } else {
          Swal.fire({
            title: "Error",
            html: respuesta.errores ?? "Ocurrió un error",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
    }
  };

  return (
    <>
      <div
        className="modal fade "
        id="m-eliminarProceso"
        tabIndex="-1 "
        aria-hidden="true "
      >
        <div className="modal-dialog modal-dialog-centered mw-900px ">
          <div className="modal-content ">
            <div className="modal-header ">
              <h2>Eliminar proceso de calificación</h2>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary "
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1 ">X</span>
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10 ">
              <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed h-lg-100 p-6">
                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                  <div className="mb-3 mb-md-0 fw-bold">
                    <h4 className="text-gray-900 fw-bolder">
                      ¿Está seguro de eliminar el Proceso de calificación
                      correspondiente al año {yearProcess}?
                    </h4>
                    <div className="fs-6 text-gray-700 pe-7">
                      Esta acción se no puede desahecer y eliminara todas las
                      etapas del proceso
                    </div>
                  </div>
                </div>
              </div>

              <textarea
                name="motivo"
                value={motivo}
                onChange={handleInputChange}
                id="motivo"
                className="form-control mt-8 mb-2"
                rows="5"
                cols="5"
                placeholder="Ingresar Motivo eliminación"
              ></textarea>
              {errores.motivo != null ? (
                <label className="text-danger">{errores.motivo}</label>
              ) : (
                <></>
              )}
              <div className="d-flex justify-content-end mt-6">
                <button
                  className="btn btn-sm btn-danger"
                  disabled={cargandoDatos}
                  onClick={eliminarProceso}
                >
                  {cargandoDatos
                    ? " Eliminando proceso"
                    : " Eliminar proceso"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
